export default "__VITE_ASSET__4cb739b5__"